const Project2 = () => {
    return (
      <div>
        <h1>Project 2: Pathfinder</h1>
        <p>This project was developed on Java with Spring Boot framework and Hibernate with MSSQL as DBMS. The purpose of this project was to create a course selection web portal.</p>
      </div>
    );
  };
  
  export default Project2;
  